import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Formenterprise from "./formenterprise";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: { width: "100%" },
  background: {
    height: "100%",
    width: "100%",
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  itemmain: {
    textAlign: "center",
    paddingTop: "2rem",
  },
  maintext: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    color: "#595A5A",
  },
  itemsecond: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
}));
const Enterprise = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <div className={classes.background}>
      <Grid container spacing={0} className={classes.root}>
        <Grid item xs={12}>
          <div className={classes.itemmain}>
            <Typography className={classes.maintext}>
              {lang.Enterprise}
            </Typography>
            <div className={classes.itemsecond}>
              <Typography className={classes.secondtext}>
                {/* Usu habeo equidem sanctus no. Suas summo id sed, erat erant
                oporteat cu pri. In eum omnes molestie. Sed ad debet scaevola,
                ne mel. */}
              </Typography>
            </div>
          </div>
        </Grid>
        <Formenterprise />
      </Grid>
    </div>
  );
};

export default Enterprise;
